import {makeAutoObservable} from 'mobx';

export class PaginationWithFilters {
  // display the visible elements
  results = [];

  //   total records will show the number of all records (not only visible results)
  totalRecords = 0;

  totalPages = null;

  currentPage = 0;

  sortBy = '';

  sortDirection = 'ASC';

  filters = {};

  filterList = [];

  // eslint-disable-next-line default-param-last
  constructor(limit, fetchPageCallBack, concat = false, sortBy) {
    this.limit = limit;
    this.fetchPageCallBack = fetchPageCallBack;
    this.concat = concat;
    this.sortBy = sortBy;
    makeAutoObservable(this);
  }

  // function to set values of totalRecords and total pages needed to validate isNextPageEnabled and isPreviousPageEnabled

  setTotals = (totalRecords) => {
    this.totalRecords = totalRecords;
    this.totalPages = Math.ceil(totalRecords / this.limit);
  };

  setLimit(limit) {
    this.limit = limit;
  }

  sort = async (byField, byDirection) => {
    this.currentPage = 0;

    if (byDirection) {
      this.sortBy = byField;
      this.sortDirection = byDirection;
    } else if (this.sortBy === byField) {
      this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortBy = byField;
      this.sortDirection = 'ASC';
    }
    await this.fetchCurrentPage();
  };

  nextPage = async () => {
    if (this.totalPages === null || this.totalPages - 1 > this.currentPage) {
      this.currentPage++;
      await this.fetchCurrentPage();
    }
  };

  previousPage = async () => {
    if (this.currentPage > 0) {
      this.currentPage--;
      await this.fetchCurrentPage();
    }
  };

  goToPage = async (pageNumber) => {
    if (this.totalPages === null || (pageNumber >= 0 && this.totalPages - 1 >= pageNumber)) {
      this.currentPage = pageNumber;
      await this.fetchCurrentPage();
    }
  };

  /**
   * Set a single filter
   * @param filters - object
   */

  setFilter(filters) {
    this.filters = filters;
    this.currentPage = 0;
  }

  /**
   * Set multiple filters
   * @param filterList - array of filter objects
   */

  setFilterList(filterList) {
    this.filterList = filterList;
    this.currentPage = 0;
  }

  fetchCurrentPage = async () => {
    const start = this.currentPage * this.limit;
    let data = {
      start,
      limit: this.limit,
      sortBy: this.sortBy,
      sortDirection: this.sortDirection,
    };

    if (this.filters && Object.keys(this.filters).length > 0) {
      data = {...data, ...this.filters};
    } else if (this.filterList && this.filterList.length > 0) {
      data.filters = this.filterList;
    }

    this.results = await this.fetchPageCallBack(data);
  };

  get isNextPageEnabled() {
    return this.totalPages === null || this.totalPages - 1 > this.currentPage;
  }

  get isPreviousPageEnabled() {
    return this.currentPage > 0;
  }
}
